
import { useEffect } from "react";
import AboutBanner from '../Components/AboutBanner'
import AboutCompany from '../Components/AboutCompany'
import AboutvaluesCards from '../Components/AboutvaluesCards'
import AboutTeam from '../Components/AboutTeam'
import TakeVideo from '../Components/TakeVideo'
import AboutInsuranceCompanies from '../Components/AboutInsuranceCompanies'
import Aboutvisitus from '../Components/Aboutvisitus'
import HomeContact from './../Components/HomeContact';


export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on mount
  }, []);
  return (
    <div className='px-5 xl:px-20 2xl:px-0'>
      <title>
        Best Hospitals in Hyderabad | Hyderabad Hospital | Magnaid
      </title>
      <meta name="description" content="MagnAid Hospitals, among the Best Hospitals in Hyderabad, offers Top Healthcare Services. A trusted Multispeciality Hospital Hyderabad for expert care always."/>
      <AboutBanner />
      <AboutCompany />
      <AboutvaluesCards />
      <AboutTeam />
      <TakeVideo />
      <AboutInsuranceCompanies />
      <Aboutvisitus />
      <HomeContact />
    </div>
  )
}
